import styled from 'styled-components';

export const CardWrapper = styled.div<{ background: string }>`
  background-color: #F4F4F5;
  border-radius: 15px;
  padding: 15px;
  overflow: hidden;
  width: 156px;
  height: 225px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  background-image: ${({ background }) => `url(${background})`};
  cursor: pointer;
`;

export const Label = styled.span`
  border-radius: 5px;
  background: #000000;
  height: 24px;
  padding: 4px 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
  font-size: 10px;
  line-height: 1.2;
  font-weight: 700;
  text-transform: uppercase;
`;
